import { render, staticRenderFns } from "./AppProductPrice.vue?vue&type=template&id=1dcf7cae&"
import script from "./AppProductPrice.vue?vue&type=script&lang=js&"
export * from "./AppProductPrice.vue?vue&type=script&lang=js&"
import style0 from "./AppProductPrice.vue?vue&type=style&index=0&id=1dcf7cae&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconInfo: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconInfo.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default,AppMemberOfferModal: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppMemberOfferModal.vue').default})
